module.exports = __webpack_public_path__ + "img/swiper-hfyh.70a8c9e7.jpg";